export const state = {
    client_signature: null,
    client_initial: null,
    client_profile:null
};



export const mutations = {
    setClientSignature(state, payload){
        state.client_signature = payload;
    },
    setClientInitials(state, payload){
        state.client_initial = payload;
    },
    setProfileData(state, payload){
        state.client_profile = payload;
    },
};

export const actions = {
    //eslint-disable-next-line
    saveClientSignature({}, payload){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/savesignature', payload)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    loadClientSignature({commit}, type){
        return new Promise((resolve, reject) => {
            window.axios.get('api/clientdocadmin/signature/' + type)
            .then( response =>{
                if(type === 'signature'){
                    commit('setClientSignature', response.data);
                }
                else{
                    commit('setClientInitials', response.data);
                }
                resolve();
            })
            .catch( err => {
                console.log('Err', err);
                reject();
            })
        })
    },
    loadClientProfile({commit}){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/clientuser/userprofile')
            .then((response) => {
                commit('setProfileData', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e);
                reject();
            })
        })
    },

};
